//Types for react-dnd
export default class ItemTypes{
  public static TAG = 'tag'
  public static COLUMN = 'column'
  public static SELECTOR = 'selector'
}
